module.exports = __webpack_public_path__ + "media/assets/faria_products/MB_PRO-91d87070cd9856f2566e3d91eb462e9b5e84ffb566451aff3edd180049c927a4.png";